export const ERROR_EFE_LIST = 'channelmap/reportefectividad/error-olas-list';
export const RECEIVE_EFE_LIST = 'channelmap/reportefectividad/receive-reportefectividad-list';
export const REQUEST_OLAS_LIST = 'channelmap/reportefectividad/request-reportefectividad-list';
export const RESTART_STATE = 'channelmap/reportefectividad/restart_state';
export const SET_MASK = 'channelmap/reportefectividad/set-mask';
export const SET_ORDER = 'channelmap/reportefectividad/set-order';
export const SET_SELECTED_ROW = 'channelmap/reportefectividad/set-selected-row';
export const UPDATE_FIELD_FILTER = 'channelmap/reportefectividad/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'channelmap/reportefectividad/set-selected-row';